<template>
  <div class="modal fade"
       id="modal-create-seller"
       tabindex="-1"
       role="dialog"
       data-bs-backdrop="static"
       data-bs-keyboard="false">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ seller ? 'Modifier le Vendeur' : 'Ajouter un Vendeur' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>
        <div class="modal-body">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <ValidationProvider name="Prénom" rules="required" v-slot="{ errors }">
                    <label class="form-label">Prénom <span class="text-danger">*</span></label>
                    <input v-model="payload.firstname" type="text" class="form-control" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
                <div class="form-group col-md-6">
                  <ValidationProvider name="Nom" rules="required" v-slot="{ errors }">
                    <label class="form-label">Nom <span class="text-danger">*</span></label>
                    <input v-model="payload.lastname" type="text" class="form-control" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
              </div>

              <div class="form-group">
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <label class="form-label">Email <span class="text-danger">*</span></label>
                  <input v-model="payload.email" type="email" class="form-control" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="form-label">Rue</label>
                  <input v-model="payload.address.street" type="text" class="form-control" placeholder="Rue" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">N°</label>
                  <input v-model="payload.address.houseNumber" type="text" class="form-control" placeholder="Ex: 12B" />
                </div>
                <div class="form-group col-md-3">
                  <label class="form-label">Code Postal</label>
                  <input v-model="payload.address.zipCode" type="text" class="form-control" placeholder="Ex: 99000" />
                </div>
              </div>

              <div class="text-end mt-4">
                <button type="button" class="btn btn-gray me-2" data-bs-dismiss="modal">Annuler</button>
                <button type="submit" class="btn btn-success" :disabled="invalid">
                  <i class="fe fe-check"></i> {{ seller ? 'Modifier' : 'Créer' }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { confirmAction, showValidationErrors } from "../../helpers/helpers";

  export default {
    name: "ModalCreateSeller",
    props: {
      seller: { type: Object, default: null },
    },
    data() {
      return {
        isEdit: !!this.seller,
        payload: {
          firstname: '',
          lastname: '',
          email: '',
          address: {
            street: '',
            houseNumber: '',
            zipCode: ''
          },
        },
      };
    },
    watch: {
      seller: {
        immediate: true,
        handler(newVal) {
          this.payload = newVal
              ? {
                firstname: newVal.firstname || '',
                lastname: newVal.lastname || '',
                email: newVal.email || '',
                address: {
                  street: newVal.address?.street || '',
                  houseNumber: newVal.address?.houseNumber || '',
                  zipCode: newVal.address?.zipCode || '',
                }
              }
              : {
                firstname: '',
                lastname: '',
                email: '',
                address: {
                  street: '',
                  houseNumber: '',
                  zipCode: ''
                }
              };
        },
      },
    },
    methods: {
      async submitForm() {
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        const confirmed = await confirmAction(this.isEdit ? 'update' : 'create');
        if (!confirmed) return;

        this.$loading(true);

        const request = this.seller
            ? this.$http.put(`/registry/sellers/${this.seller.id}`, this.payload)
            : this.$http.post("/registry/sellers", this.payload);

        request
            .then(() => {
              this.$refs.observer.reset();
              this.$emit("refresh");
              $('#modal-create-seller').modal('hide');
              setTimeout(() => swal("Succès", "Vendeur enregistré avec succès", "success"), 300);
            })
            .catch(err => {
              console.error(err);
              showValidationErrors(err);
            })
            .finally(() => this.$loading(false));
      },
    },
  };
</script>
